import { useEffect, useState } from 'react';
import { telemetryService } from '@services/api/telemetryService';
import { IntegrationStatus } from '@components/dashboard/IntegrationStatus';

export const SystemMonitor = () => {
  const [errorSummary, setErrorSummary] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSystemData();
  }, []);

  const loadSystemData = async () => {
    const result = await telemetryService.getErrorSummary('24h');
    if (result.success && result.data) {
      setErrorSummary(result.data);
    }
    setLoading(false);
  };

  return (
    <div>
      <h1 className="page-title">System Monitor</h1>
      <p className="page-subtitle">Integration health, errors, and performance metrics</p>

      <div style={{ marginTop: 'var(--spacing-xxl)' }}>
        <IntegrationStatus />
      </div>

      <div className="info-card" style={{ marginTop: 'var(--spacing-xl)' }}>
        <h3 className="info-card-title">🚨 Error Summary (Last 24 Hours)</h3>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="info-grid">
            <div className="info-item">
              <span className="info-label">Total Errors</span>
              <span className="info-value">{errorSummary?.total_errors || 0}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Unique Errors</span>
              <span className="info-value">{errorSummary?.unique_errors || 0}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Affected Users</span>
              <span className="info-value">{errorSummary?.affected_users || 0}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

